import React from "react";
import PropTypes from "prop-types";
import styled, { withTheme } from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import TabsContainer from "./tabs";

const Wrapper = styled.div`
  background-color: ${cloud.getShade(2)};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

const SimplePanel = ({ isbn }) => {
  return (
    <Wrapper>
      <TabsContainer isbn={isbn} />
    </Wrapper>
  );
};

SimplePanel.propTypes = {
  isbn: PropTypes.string.isRequired
};

export default SimplePanel;
